<div class="atn-mosaic-dev-variable">
  <atn-ds-text
    label="ID"
    placeholder="Enter Id"
    [value]="definitionIdSg()"
    (change)="updateDefinition('id', $event ?? '')"
  />
  <atn-ds-text
    label="Name"
    placeholder="Enter a name"
    [value]="definitionNameSg()"
    (change)="updateDefinition('name', $event ?? '')"
  />
  <atn-ds-select-single
    label="Type"
    [value]="selectedDefinitionTypeSg()"
    [items]="definitionTypeSelectItems"
    (valueChange)="updateDefinitionType($event)"
  />
  @if (isOtherTypeSelectedSg()) {
    <atn-ds-code
      class="atn-mosaic-dev-variable__code-editor"
      label="Define Type"
      [json]="otherTypeSg()"
      (jsonChange)="updateOtherType($event)"
    />
  }
  <atn-display-value
    label="Default Value"
    [value]="definitionDefaultValueSg()"
    [type]="definitionTypeSg()"
    (valueChange)="updateDefinition('defaultValue', $event)"
  />
  <atn-ds-text
    label="Description"
    placeholder="Enter description"
    [value]="definitionDescriptionSg()"
    (change)="updateDefinition('description', $event)"
  />
</div>
